<template>
  <span class="tw-inline-flex tw-py-1.5 tw-pb-1">
    <span
      class="sf-pointer fa fa-trash"
      :class="classes"
      data-testid="delete"
      @click="handleClick"
    >
    </span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  disabled?: boolean
}

const props = defineProps<Props>()

const classes = computed(() => {
  return {
    'tw-text-sf-gray-lighter': props.disabled,
    '!tw-cursor-not-allowed': props.disabled,
  }
})

const emit = defineEmits(['delete'])

function handleClick() {
  if (!props.disabled) {
    emit('delete')
  }
}
</script>
